module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/3-2b1f39efa3cbf6d4d394ba3a4d92bb83.png";